<div class="app-container">
    @if (!isLoginPage()) {
    <app-side-nav />
    }
    <div class="main-view">
        <router-outlet />
        @if (!isLoginPage()) {
        <app-planta-chip />
        }
    </div>
</div>